import { type ReactElement } from 'react';
import Input from '@creditflowresearch/uilib/Input';
import Flex from '@creditflowresearch/uilib/Flex';
import FilterSection from '@/creditflowresearch/ui/common/components/templates/FilterSection';
import FilterSectionHeader from '@/creditflowresearch/ui/common/components/organisms/FilterSectionHeader';
import useSize from './useSize';
import {
  FilterSectionIds,
} from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/constants';

import rangeStyles from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/rangeFilter.module.scss';
import styles from './size.module.scss';

const Size = (): ReactElement => {
  const { dealSize, trancheSize } = useSize();

  return (
    <FilterSection
      sectionId={ FilterSectionIds.Size }
      header={ <FilterSectionHeader title="SIZE (M)" /> }
      dataTest="sizeSection"
    >
      <div className={ styles.rangeLabel }>deal size (M)</div>
      <Flex gap={ 8 } className={ styles.rangeRow }>
        { /* @ts-ignore */ }
        <Input
          name="dealSizeMin"
          type="text"
          placeholder="Min"
          value={ dealSize.minValue }
          onChange={ dealSize.handleMinChange }
          meta={ dealSize.minMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="dealSizeMin"
          isClearable={ false }
        />
        <span className={ styles.separator }>-</span>
        { /* @ts-ignore */ }
        <Input
          name="dealSizeMax"
          type="text"
          placeholder="Max"
          value={ dealSize.maxValue }
          onChange={ dealSize.handleMaxChange }
          meta={ dealSize.maxMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="dealSizeMax"
          isClearable={ false }
        />
      </Flex>
      <div className={ styles.rangeLabel }>tranche size (M)</div>
      <Flex gap={ 8 } className={ styles.rangeRow }>
        { /* @ts-ignore */ }
        <Input
          name="trancheSizeMin"
          type="text"
          placeholder="Min"
          value={ trancheSize.minValue }
          onChange={ trancheSize.handleMinChange }
          meta={ trancheSize.minMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="filterMinInput"
          isClearable={ false }
        />
        <span className={ styles.separator }>-</span>
        { /* @ts-ignore */ }
        <Input
          name="trancheSizeMax"
          type="text"
          placeholder="Max"
          value={ trancheSize.maxValue }
          onChange={ trancheSize.handleMaxChange }
          meta={ trancheSize.maxMeta }
          formFieldClassName={ rangeStyles.field }
          inputClassName={ rangeStyles.input }
          dataTest="filterMaxInput"
          isClearable={ false }
        />
      </Flex>
    </FilterSection>
  );
};

export default Size;
